<template>
  <div class="company-container">
    <!-- Modal -->
    <ModalCreateDepartment
      ref="department"
      :isShowModal="isModalActiveDepartment"
      @changeModal="changeModalCreateDepartment"
      @createDepartment="createDepartment"/>
    <ModalCreatePosition
      ref="position"
      :isShowModal="isModalActivePosition"
      @changeModal="changeModalCreatePosition"
      @createPosition="createPosition"/>
    <ModalCreateCompanyHomePage
      ref="companyhomepage"
      :isShowModal="isModalActiveCompanyHomePage"
      @changeModal="changeModalCreateCompanyHomePage"
      @createCompanyHomePage="createCompanyHomePage"/>
    <ModalCreateTag
      ref="robotag"
      :isShowModal="isModalActiveTag"
      @changeModal="changeModalCreateTag"
      @createTag="createTag"/>
    <ModalImportDepartment
      :isShowModal="isModalActiveImportDepartment"
      :isLoadingModal="isLoadingModal"
      @changeModal="changeModalImportDepartment"
      @bulkCreateDepartment="bulkCreateDepartment"/>
    <ModalImportPosition
      :isShowModal="isModalActiveImportPosition"
      :isLoadingModal="isLoadingModal"
      @changeModal="changeModalImportPosition"
      @bulkCreatePosition="bulkCreatePosition"/>
    <ModalImportTag
      :isShowModal="isModalActiveImportTag"
      :isLoadingModal="isLoadingModal"
      @changeModal="changeModalImportTag"
      @bulkCreateTag="bulkCreateTag"/>

    <div class="block-container disp-scroll">
      <b-tabs type="is-boxed" size="is-small">
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-account-circle mdi-24px" style="margin-left:8px;"></span>
              <span> 会社情報 </span>
          </template>
          <div class="edit-field">
            <b-field>
              <h1 v-if="user.permission===0"> 会社情報の変更　※最下部の「変更する」ボタンを押さないと反映されませんのでご注意下さい。 </h1>
              <h1 v-else> 会社情報 </h1>
              <div class="blank"></div>
            </b-field>
            <hr>
            <b-field label="会社名" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.companyName" maxlength="100"></b-input>
            </b-field>
            <b-field label="会社名" style="text-align: left;" v-else>
              <div> {{user.companyName}} </div>
            </b-field>
            <b-field label="Email" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.companyEmail" maxlength="254"></b-input>
            </b-field>
            <b-field label="Email" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;"> {{user.companyEmail}} </div>
            </b-field>
            <b-field label="サブEmail（カンマ区切りで複数設定）" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.company_email_sub" maxlength="500"></b-input>
            </b-field>
            <b-field label="Email" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;"> {{user.company_email_sub}} </div>
            </b-field>
            <b-field label="TEL" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.companyTEL" maxlength="100"></b-input>
            </b-field>
            <b-field label="TEL" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;"> {{user.companyTEL}} </div>
            </b-field>
            <b-field label="SMS用番号（[+nnnnnnnnnnn]または[(+n)(nnn) nnn-nnnn]の形式で入力してください。）" style="text-align: left;" v-if="user.permission===0&&user.isAgent">
              <b-input v-model="user.companySMSTEL" maxlength="500"></b-input>
            </b-field>
            <b-field label="URL" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.companyURL" maxlength="100"></b-input>
            </b-field>
            <b-field label="URL" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;"> {{user.companyURL}} </div>
            </b-field>
            <b-field label="住所" style="text-align: left;" v-if="user.permission===0">
              <b-input v-model="user.address" maxlength="300"></b-input>
            </b-field>
            <b-field label="住所" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;"> {{user.address}} </div>
            </b-field>
            <b-field label="ユーザー管理：パスワード変更【定期強制】" style="text-align: left;" v-if="user.permission===0&&user.isAgent">
              <b-switch v-model="user.pass_notify_flag">
                {{user.pass_notify_flag ? 'ON' : 'OFF'}}（設定日：{{ formattedPassNotifyChgDate }}）
              </b-switch>
            </b-field>
            <b-field label="ユーザー管理：パスワード変更【定期強制】" style="text-align: left;" v-else>
              <div style="display: flex; align-items: center; margin-left: 0; width: 350px;">
                <span>{{ user.pass_notify_flag ? 'ON' : 'OFF' }}</span>
                <span style="margin-left: 8px;">（設定日：{{ formattedPassNotifyChgDate }}）</span>
              </div>
            </b-field>
            <div style="width: 85%;">
              <p style="padding: 15px 0 0 0; font-weight: bold; font-size: small;">※セキュリティ強化について、オンにされたい場合にはお問合せ下さい。</p>
            </div>
            <b-field label="プラスアイ求人情報取込状態" style="text-align: left;" v-if="user.companyPLUSIURL">
              <div style="margin-left: 0; width: 100px;" v-if="user.companyPLUSISTATE==0"> 設定有 </div>
              <div style="margin-left: 0; width: 100px;" v-else> 連携エラー </div>
            </b-field>
            <b-field label="プラスアイ求人情報取込用URL（/まで入力してください）" style="text-align: left;" v-if="user.permission===0&&user.isAgent">
              <b-input v-model="user.companyPLUSIURL" maxlength="200"></b-input>
            </b-field>
            <b-field label="プラスアイ応募者取り込み用トークン" style="text-align: left;" v-if="user.permission===0&&user.isAgent">
              <div>
                <div style="margin-bottom: 4px"><button class="button is-info" @click="createPlusiToken()">発行</button></div>
                <b-input v-model="plusiToken" maxlength="200" readonly></b-input>
              </div>
            </b-field>
            <b-field label="採用フロー自動化" style="text-align: left;" v-if="user.permission===0">
              <b-switch v-model="user.is_recruitment_flow">
                {{user.is_recruitment_flow ? 'ON' : 'OFF'}}
              </b-switch>
            </b-field>
            <b-field label="採用フロー自動化" style="text-align: left;" v-else>
              <div style="margin-left: auto; width: 250px;">
                {{user.is_recruitment_flow ? 'ON' : 'OFF'}}
              </div>
            </b-field>
            <div style="display:flex">
              <div style="width: 15%;">
                <b-field label="応募フォームロボ化" style="text-align: left;" v-if="user.permission===0">
                    <b-switch
                      v-model="user.subscribe_employmentpage_status"
                      :true-value="1"
                      :false-value="0">
                      {{user.subscribe_employmentpage_status === 1 ? 'ON' : 'OFF'}}
                    </b-switch>
                </b-field>
                <b-field label="応募フォームロボ化" style="text-align: left;" v-else>
                  <div style="margin-left: auto; width: 250px;"> {{user.subscribe_employmentpage_status === 1 ? 'ON' : 'OFF'}}</div>
                </b-field>
              </div>
              <div style="width: 85%;">
                <p style="padding: 15px 0 0 0; font-weight: bold; font-size: small;">※各求人原稿の応募エントリーにロボを設置する際（応募フォームロボ化設定）は、<br>　初回起動設定が空欄の場合、表示されない場合があります。</p>
              </div>
            </div>
            <b-field label="Picture" style="text-align: left;">
              <div style="width: 250px; flex-direction: column; display: flex;">
                <img v-show="user.company_page"
                  :src="imageUrl"
                  style="margin-right: auto; max-width: 100px; max-height: 100px; border-radius:15px; border: solid thin #ccc; margin-bottom: 16px;"/>
                <ModalSelectMedia @updated='setIcon'></ModalSelectMedia>
                <a id="CompanySetting-0001" class="button is-fullwidth" @click="modalActive()"><span class="mdi mdi-image-plus" style="margin-right: 5px;"></span>会社ページ</a>
              </div>
            </b-field>
            <a class="button is-primary"
              @click="setProfile({
                  'company_url': user.companyURL,
                  'company_name': user.companyName,
                  'company_tel': user.companyTEL,
                  'company_sms_tel': user.companySMSTEL,
                  'company_email': user.companyEmail,
                  'company_email_sub': user.company_email_sub,
                  'address': user.address,
                  'is_recruitment_flow': user.is_recruitment_flow,
                  'pass_notify_flag': user.pass_notify_flag,
                  'subscribe_employmentpage_status': user.subscribe_employmentpage_status,
                  'company_plusi_url': user.companyPLUSIURL,
                  'company_plusi_token': user.companyPLUSITOKEN
                },
                'company')">変更する</a>
          </div>
        </b-tab-item>
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-city-variant-outline mdi-24px" style="margin-left:8px;"></span>
              <span> 組織情報 </span>
          </template>
          <div>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveDepartment=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              部門の追加
            </button>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveImportDepartment=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              部門のCSVインポート
            </button>
            <button class="button is-small" style="margin-bottom: 8px;" @click="exportDepartment()">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              部門のCSVエクスポート
            </button>
            <table class="table-box">
              <tr>
                <th class="table-box-header">名前</th>
                <th class="table-box-header">住所</th>
                <th class="table-box-header">説明</th>
                <th class="table-box-header">アクション</th>
              </tr>
              <tr v-for="(d, idx) in sortedDepartments" :key="idx" v-if="sortedDepartments.length > 0">
                <td>
                  <div style="display: flex; align-items: center;">
                    <span class="mdi mdi-subdirectory-arrow-right" style="margin-right: 4px; font-size: 16px;" :style="{'margin-left': (d.depth * 16) + 'px'}" v-if="d.depth > 0"></span>
                    <input class="input input-table" style="min-width: 200px;" v-model="d.name"/>
                  </div>
                </td>
                <td>
                  <div style="display: flex; align-items: center;">
                    <input class="input input-table" style="min-width: 200px;" @input="setAddressFromPostalCode($event, idx)" v-model="d.postal_code" placeholder="123-4567" />
                  </div>
                  <div style="display: flex; align-items: center;">
                    <input class="input input-table" style="min-width: 200px;" v-model="d.region" placeholder="東京都"/>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <input class="input input-table" style="min-width: 200px;" v-model="d.locality" placeholder="新宿区"/>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <input class="input input-table" style="min-width: 200px;" v-model="d.street" placeholder="4-5-1 新宿ビル478号室" />
                  </div>
                </td>
                <td>
                  <textarea class="entered textarea" style="min-width: 200px;" v-model="d.description"></textarea>
                </td>
                <td>
                  <button class="button is-primary is-small" @click="$refs.department.parentDepartment=d.pk;isModalActiveDepartment=true" :disabled="d.depth > 1">子組織を追加</button>
                  <button class="button is-small" @click="updateDepartment(d)">組織を保存</button>
                  <button class="button is-danger is-small" @click="deleteDepartment(d.pk)">組織を削除</button>
                </td>
              </tr>
            </table>
          </div>
        </b-tab-item>
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-clipboard-account mdi-24px" style="margin-left:8px;"></span>
              <span> 役職情報 </span>
          </template>
          <div>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActivePosition=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              役職の追加
            </button>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveImportPosition=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              役職のCSVインポート
            </button>
            <button class="button is-small" style="margin-bottom: 8px;" @click="exportPosition()">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              役職のCSVエクスポート
            </button>
            <table class="table-box">
              <tr>
                <th class="table-box-header">名前</th>
                <th class="table-box-header">説明</th>
                <th class="table-box-header">アクション</th>
              </tr>
              <tr v-for="(p, idx) in sortedPositions" :key="idx" v-if="sortedPositions.length > 0">
                <td>
                  <div style="display: flex; align-items: center;">
                    <span class="mdi mdi-subdirectory-arrow-right" style="margin-right: 4px; font-size: 16px;" :style="{'margin-left': (p.depth * 16) + 'px'}" v-if="p.depth > 0"></span>
                    <input class="input input-table" style="min-width: 300px;" v-model="p.name"/>
                  </div>
                </td>
                <td>
                  <input class="input input-table" style="min-width: 300px;" v-model="p.description"/>
                </td>
                <td>
                  <button class="button is-primary is-small" @click="$refs.position.parentPosition=p.pk;isModalActivePosition=true" :disabled="p.depth > 1">役職を追加</button>
                  <button class="button is-small" @click="updatePosition(p)">役職を保存</button>
                  <button class="button is-danger is-small" @click="deletePosition(p.pk)">役職を削除</button>
                </td>
              </tr>
            </table>
          </div>
        </b-tab-item>
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-book-multiple mdi-24px" style="margin-left:8px;"></span>
              <span> 会社ページ </span>
          </template>
          <div>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveCompanyHomePage=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              会社ページの追加
            </button>
            <table class="table-box">
              <tr>
                <th class="table-box-header">ページ名</th>
                <th class="table-box-header">説明</th>
                <th class="table-box-header">検索ワード</th>
                <th class="table-box-header">URL</th>
                <th class="table-box-header">アクション</th>
              </tr>
              <template v-for="(chp, idx) in companyHomePages">
                <tr :key="idx" v-if="companyHomePages.length > 0">
                  <td>
                    <input class="input input-table" style="min-width: 120px;" v-model="chp.title"/>
                  </td>
                  <td>
                    <input class="input input-table" style="min-width: 120px;" v-model="chp.description"/>
                  </td>
                  <td>
                    <input class="input input-table" style="min-width: 200px;" v-model="chp.search_word"/>
                  </td>
                  <td>
                    <input class="input input-table" style="min-width: 300px;" v-model="chp.url"/>
                  </td>
                  <td>
                    <button class="button is-small" @click="updateCompanyHomePage(chp)">保存</button>
                    <button class="button is-danger is-small" @click="deleteCompanyHomePage(chp.id)">削除</button>
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </b-tab-item>
        <b-tab-item>
          <template slot="header" class="header">
              <span class="mdi mdi-tag-multiple mdi-24px" style="margin-left:8px;"></span>
              <span> タグ情報 </span>
          </template>
          <div>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveTag=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              タグの追加
            </button>
            <button class="button is-primary is-small" style="margin-bottom: 8px;" @click="isModalActiveImportTag=true">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              タグのCSVインポート
            </button>
            <button class="button is-small" style="margin-bottom: 8px;" @click="exportTag()">
              <span class="mdi mdi-plus" style="margin-right: 4px;"></span>
              タグのCSVエクスポート
            </button>
            <table class="table-box">
              <tr>
                <th class="table-box-header">タグ名</th>
                <th class="table-box-header">説明</th>
                <th class="table-box-header">アクション</th>
              </tr>
              <tr v-for="(d, idx) in sortedTags" :key="d.pk" v-if="sortedTags.length > 0">
                <td>
                  <b-field>
                    <b-input style="min-width: 300px;" maxlength="20" v-model="d.name" placeholder="タグ名" required/>
                  </b-field>
                </td>
                <td>
                  <b-field>
                    <b-input style="min-width: 300px;" maxlength="255" v-model="d.description" placeholder="説明"/>
                  </b-field>
                </td>
                <td>
                  <button class="button is-small" @click="updateTag(d)" :disabled="!isValid(d.name)">タグを保存</button>
                  <button class="button is-danger is-small" @click="deleteTag(d.pk)">タグを削除</button>
                </td>
              </tr>
            </table>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalSelectMedia           from '@/components/ui/ModalSelectMedia'
import ModalCreateDepartment      from '@/views/DashBoard/Setting/ModalCreateDepartment'
import ModalCreatePosition        from '@/views/DashBoard/Setting/ModalCreatePosition'
import ModalCreateCompanyHomePage from '@/views/DashBoard/Setting/ModalCreateCompanyHomePage'
import ModalCreateTag             from '@/views/DashBoard/Setting/ModalCreateTag'
import ModalImportDepartment      from '@/views/DashBoard/Setting/ModalImportDepartment'
import ModalImportPosition        from '@/views/DashBoard/Setting/ModalImportPosition'
import ModalImportTag             from '@/views/DashBoard/Setting/ModalImportTag'
import controlLogMixin from '@/mixins/controlLogMixin'
import { Core as YubinBangoCore } from 'yubinbango-core'
import createUUID from '@/functions/createUUID'
export default {
  name: 'CompanySetting',
  componentName: 'CompanySetting',
  components: {
    ModalSelectMedia,
    ModalCreateDepartment,
    ModalCreatePosition,
    ModalCreateCompanyHomePage,
    ModalCreateTag,
    ModalImportDepartment,
    ModalImportPosition,
    ModalImportTag
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      uploadedImage: null,
      filename: 'no file',
      repassword: '',
      inputs: {
        company: '',
        username: '',
        email: ''
      },
      isFileUp: false,
      image: null,
      isModalActiveDepartment: false,
      isModalActiveImportDepartment: false,
      isModalActivePosition: false,
      isModalActiveImportPosition: false,
      isModalActiveCompanyHomePage: false,
      isModalActiveTag: false,
      isModalActiveImportTag: false,
      isLoadingModal: false,
      departmentName: null,
      positionName: null,
      parentDepartment: null,
      parentPosition: null,
      departmentDescription: null,
      positionDescription: null,
      tagName: null,
      tagDescription: null,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'departments', 'positions', 'companyHomePages']),
    ...mapState('mediapool', ['selectModalTarget']),
    ...mapState('chatbot', ['chatbottags']),
    sortedDepartments () {
      let tempDepartments = this.departments
      let retDepartments = []
      // 階層は3階層まで
      for (const i in tempDepartments) {
        if (!tempDepartments[i].department) {
          let temp = tempDepartments[i]
          temp.depth = 0
          retDepartments.push(temp)
          tempDepartments.splice(i, 0)
          for (const i in tempDepartments) {
            if (tempDepartments[i].department === temp.pk) {
              let tempDepthOne = tempDepartments[i]
              tempDepthOne.depth = 1
              retDepartments.push(tempDepthOne)
              tempDepartments.splice(i, 0)
              for (const i in tempDepartments) {
                if (tempDepartments[i].department === tempDepthOne.pk) {
                  let tempDepthTwo = tempDepartments[i]
                  tempDepthTwo.depth = 2
                  retDepartments.push(tempDepthTwo)
                  tempDepartments.splice(i, 0)
                }
              }
            }
          }
        }
      }
      return retDepartments
    },
    sortedPositions () {
      let tempPositions = this.positions
      let retPositions = []
      // 階層は3階層まで
      for (const i in tempPositions) {
        if (!tempPositions[i].position) {
          let temp = tempPositions[i]
          temp.depth = 0
          retPositions.push(temp)
          tempPositions.splice(i, 0)
          for (const i in tempPositions) {
            if (tempPositions[i].position === temp.pk) {
              let tempDepthOne = tempPositions[i]
              tempDepthOne.depth = 1
              retPositions.push(tempDepthOne)
              tempPositions.splice(i, 0)
              for (const i in tempPositions) {
                if (tempPositions[i].position === tempDepthOne.pk) {
                  let tempDepthTwo = tempPositions[i]
                  tempDepthTwo.depth = 2
                  retPositions.push(tempDepthTwo)
                  tempPositions.splice(i, 0)
                }
              }
            }
          }
        }
      }
      return retPositions
    },
    sortedTags () {
      return this.chatbottags.slice().sort((x, y) => {return (x.pk < y.pk ? -1 : 1)})
    },
    imageUrl () {
      if (this.selectModalTarget.data) {
        return this.selectModalTarget.data.image_data
      } else {
        return this.user.company_page
      }
    },
    plusiToken () {
        return this.user.companyPLUSITOKEN
    },
    formattedPassNotifyChgDate() {
      return this.user.pass_notify_chg_date ? this.formatDate(this.user.pass_notify_chg_date) : '日付なし';
    }
  },
  created() {
    // `created`フック内で`initialPassNotifyFlag`を設定
    this.initialPassNotifyFlag = this.user.pass_notify_flag;
  },
  methods: {
    modalActive () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    getCurrentDate() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    let yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
    },
    setProfile (data, type) {
      // pass_notify_flagがfalseからtrueに変わった場合のみ日付を更新
      if (!this.initialPassNotifyFlag && data.pass_notify_flag) {
        data.pass_notify_chg_date = this.getCurrentDate();
      }
      this.sendControlLog('会社情報　変更', '会社情報画面にて、「変更する」ボタンをクリックした。')
      console.debug('*** Start *** setProfile')
      console.debug('data: ' + JSON.stringify(data))
      console.debug('type: ' + JSON.stringify(type))
      const pattern = /^\+[0-9]{11}|\(\+\d{1}\)\(\d{3}\)\s\d{3}-\d{4}$/
      if(data.company_sms_tel.match(pattern) === null && data.company_sms_tel !== '') {
        alert('SMS用番号の形式に誤りがあります。')
        return
      }
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
        .then(() => { if (this.error) { this.errorBar(this.error) } })
        .then(() => { if (!this.error) { this.successBar() } })
      console.debug('*** End *** setProfile')
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。再読み込みしてください。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    // アップロード時発火
    onFileChange (e) {
      console.debug('*** Start *** onFileChange')
      console.error('e: ' + JSON.stringify(e))
      let files = e.target.files || e.dataTransfer.files
      let reader = new FileReader()
      reader.onload = (e) => {
        this.image = e.target.result
        this.uploadedImage = e.target.result
        var jsonData = {
          name: files[0].name,
          image: e.target.result.replace(/^.*,/, '')
        }
        this.$store.dispatch('auth/companyPageSave', jsonData)
        console.log(this.image)
      }
      reader.readAsDataURL(files[0])
      console.debug('*** End *** onFileChange')
    },
    setIcon (id){
      this.$store.dispatch('auth/companyPageSave', {image_id: id})
    },
    bulkCreateDepartment (data) {
      this.isLoadingModal = true
      this.$store.dispatch('auth/bulkCreateDepartment', data)
        .then(() => {
          this.isLoadingModal = false
          this.isModalActiveImportDepartment = false
        })
    },
    createDepartment (data) {
      this.$store.dispatch('auth/createDepartment', {
        name: data.departmentName,
        description: data.departmentDescription,
        company: this.user.companyPK,
        department: data.parentDepartment,
        postal_code: data.departmentPostalCode,
        region: data.departmentRegion,
        locality: data.departmentLocality,
        street: data.departmentStreet
      })
      this.isModalActiveDepartment = false
    },
    createPosition (data) {
      this.$store.dispatch('auth/createPosition', {
        name: data.positionName,
        description: data.positionDescription,
        company: this.user.companyPK,
        department: data.parentPosition
      })
      this.isModalActivePosition = false
    },
    createCompanyHomePage (data) {
      this.$store.dispatch('auth/createCompanyHomePage', {
        title: data.title,
        search_word: data.searchWord,
        url: data.url,
        description: data.description,
        company: this.user.companyPK,
      })
      this.isModalActiveCompanyHomePage = false
    },
    createTag (data) {
      this.$store.dispatch('chatbot/createChatBotTag', {
        name: data.tagName,
        description: data.tagDescription,
        company: this.user.companyPK,
      })
      this.isModalActiveTag = false
    },
    bulkCreatePosition (data) {
      this.isLoadingModal = true
      this.$store.dispatch('auth/bulkCreatePosition', data)
        .then(() => {
          this.isLoadingModal = false
          this.isModalActiveImportPosition = false
        })
    },
    bulkCreateTag (data) {
      this.isLoadingModal = true
      this.$store.dispatch('chatbot/bulkCreateChatbotTag', data)
        .then(() => {
          this.isLoadingModal = false
          this.isModalActiveImportTag = false
        })
    },
    updateDepartment (data) {
      this.$store.dispatch('auth/updateDepartment', data)
    },
    updatePosition (data) {
      this.$store.dispatch('auth/updatePosition', data)
    },
    updateCompanyHomePage (data) {
      this.$store.dispatch('auth/updateCompanyHomePage', data)
    },
    updateTag (data) {
      this.$store.dispatch('chatbot/updateChatBotTag', data)
        .then(() => {
          if (!this.error) { 
            this.$buefy.snackbar.open({
              message: JSON.stringify(data.name) + 'に変更されました',
              type: 'is-success',
              position: 'is-top'
            })
          } else {
            this.errorBar(this.error)
          }
        })
    },
    deleteDepartment (id) {
      this.$store.dispatch('auth/deleteDepartment', id)
    },
    deletePosition (id) {
      this.$store.dispatch('auth/deletePosition', id)
    },
    deleteCompanyHomePage (id) {
      this.$store.dispatch('auth/deleteCompanyHomePage', id)
    },
    deleteTag (id) {
      this.$store.dispatch('chatbot/deleteChatBotTag', id)
    },
    changeModalCreateDepartment (flg) {
      this.isModalActiveDepartment = flg
    },
    changeModalCreatePosition (flg) {
      this.isModalActivePosition = flg
    },
    changeModalCreateCompanyHomePage (flg) {
      this.isModalActiveCompanyHomePage = flg
    },
    changeModalCreateTag (flg) {
      this.isModalActiveTag = flg
    },
    changeModalImportDepartment (flg) {
      this.isModalActiveImportDepartment = flg
    },
    changeModalImportPosition (flg) {
      this.isModalActiveImportPosition = flg
    },
    changeModalImportTag (flg) {
      this.isModalActiveImportTag = flg
    },
    // export
    exportDepartment () {
      this.$store.dispatch('auth/exportDepartment')
        .then((data) => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          let blob = new Blob([bom, data], { "type" : "text/csv" })
          let downLoadLink = document.createElement('a')
          downLoadLink.download = '組織情報.csv'
          downLoadLink.href = URL.createObjectURL(blob)
          downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
          downLoadLink.click()
          alert('エクスポート完了しました')
        })
    },
    exportPosition() {
      this.$store.dispatch('auth/exportPosition')
        .then((data) => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          let blob = new Blob([bom, data], { "type" : "text/csv" })
          let downLoadLink = document.createElement('a')
          downLoadLink.download = '役職情報.csv'
          downLoadLink.href = URL.createObjectURL(blob)
          downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
          downLoadLink.click()
          alert('エクスポート完了しました')
        })
    },
    exportTag () {
      this.$store.dispatch('chatbot/exportChatBotTag')
        .then((data) => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          let blob = new Blob([bom, data], { "type" : "text/csv" })
          let downLoadLink = document.createElement('a')
          downLoadLink.download = 'タグ情報.csv'
          downLoadLink.href = URL.createObjectURL(blob)
          downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
          downLoadLink.click()
          alert('エクスポート完了しました')
        })
    },
    setAddressFromPostalCode(event,id) {
      let postalcode = event.target.value
      if(postalcode.length >= 7) {
        new YubinBangoCore(postalcode, (addr) => {
          if(addr.region) {
            this.sortedDepartments[id].region = addr.region // 都道府県
          } else {
            alert('ご指定の郵便番号では住所が見つかりませんでした')
          }
          if(addr.locality) {
            this.sortedDepartments[id].locality = addr.locality + addr.street // 市区町村
          }
        })
      }
    },
    createPlusiToken() {
      this.user.companyPLUSITOKEN = createUUID()
    },
    /** フォームが有効かどうかを返す */
    isValid(value) {
       if (value.length > 0 && value.length < 21) return true
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      return `${year}年${month}月${day}日`;
    }
  }
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.modal-box {
  border-radius: 8px;
  padding: 24px;
  background: white;
}
.company-container {
  margin: 0;
  height: calc(100vh - 80px);
}
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.block-container {
  height: calc(100vh - 80px);
  padding: 20px;
  width: 100%;
  flex-flow: column nowrap;
}
.edit-field{
  padding: 20px;
}
h1 {
  font-weight: 700;
  font-size: 20px;
}
.blank {
  width: 150px;
}
.tab-content {
  height: 360px;
}
.tab-item {
  margin: 24px 0 0 40px;
}
.tab-item {
  text-align: left;
}
.check-item {
  width: 33%;
  padding-bottom: 16px;
}
/* buefy */
.b-checkbox.checkbox + .checkbox {
  margin-left: 0;
}

/* upload button */
.icon-modify {
  width: 100px;
  position: relative;
}
.icon-modify > input {
  display: none;
}

.tab-box-form {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
  border-right: solid 2px #ccc;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/CompanySetting.vue